import { useState, useEffect } from 'react';
import colombiaFlag from '../assets/img/flags/colombia.png';
import ecuadorFlag from '../assets/img/flags/ecuador.png';
import panamaFlag from '../assets/img/flags/panama.png';
import mexicoFlag from '../assets/img/flags/mexico.png';
import spainFlag from '../assets/img/flags/espana.png';
import usaFlag from '../assets/img/flags/estados-unidos.png';

export const FLAGS_LISTS = [
    { name: 'colombia', flag: colombiaFlag },
    { name: 'ecuador', flag: ecuadorFlag },
    { name: 'panama', flag: panamaFlag },
    { name: 'mexico', flag: mexicoFlag },
    { name: 'espana', flag: spainFlag },
    { name: 'usa', flag: usaFlag },
];

export const goToPage = (url) => {
    // If the URL is absolute (starts with http:// or https://)
    if (/^https?:\/\//i.test(url)) {
        window.location.href = url;
    } else {
        // Otherwise, treat it as a relative path in your app
        window.location.href = url.startsWith('/') ? url : `/${url}`;
    }
};

export const useDebounce = (value, delay = 500) => {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(handler);
    }, [value, delay]);

    return debounced;
};
